import React from 'react';
import { 
  DeepThinkIcon,
  NewsIcon,
  BlueprintIcon,
  LaunchIcon,
  CancelIcon,
  RegulationsRoundIcon,
  HandshakeIcon,
  ValidationIcon,
  DocumentIcon,
} from "components/Icons";

export const reportTypeItems = [
  {
    name: 'In-Depth Analysis',
    value: 'researchReport',
    path: '/research?t=researchReport',
    target: '_blank',
    icon: <DeepThinkIcon size={32} />,
    color: 'var(--primary-color-400)',
    title:
      'Pulls fresh, real-time data from the internet to ensure the latest market insights. Expands on topics with thorough analysis, context, and strategic insights.',
  },
  {
    name: 'News Signals & Target Lists',
    value: 'newsReport',
    path: '/research?t=newsReport',
    target: '_blank',
    icon: <NewsIcon size={32} />,
    color: 'green',
    title:
      'Track the latest news and create curated lists of emerging players across the clean tech landscape',
  },
  {
    name: 'Business Blueprint',
    value: 'companyReport',
    path: '/research?t=companyReport',
    target: '_blank',
    icon: <BlueprintIcon size={32} />,
    color: 'black',
    title:
      'Track commercial signals of any energy company—strategy, partnerships, and investments.',
  },
  {
    name: 'SWOT Analysis',
    value: 'swotReport',
    path: '/research?t=swotReport',
    target: '_blank',
    icon: <DocumentIcon size={32} />,
    color: 'var(--primary-color-500)',
    title:
      'Generate a two-period SWOT analysis with Strengths, Weaknesses, Opportunities, and Threats backed by linked evidence.',
  },
  {
    name: 'PESTL Analysis',
    value: 'pestlReport',
    path: '/research?t=pestlReport',
    target: '_blank',
    icon: <ValidationIcon size={32} />,
    color: 'var(--accent-color-3)',
    title:
      'Build a Political, Economic, Social, Technological, Legal & Regulatory analysis that contrasts signals across timeframes.',
  },
  {
    name: 'Largest Clean Tech Deployments',
    value: 'installationAnalysis',
    path: '/research?t=installationAnalysis',
    target: '_blank',
    icon: <LaunchIcon size={32} />,
    color: 'teal',
    title: 'Track the largest cleantech deployments—projects, investments, and trends.',
  },
  {
    name: 'Canceled Clean Tech Projects',
    value: 'cancellationAnalysis',
    path: '/research?t=cancellationAnalysis',
    target: '_blank',
    icon: <CancelIcon size={32} />,
    color: 'red',
    title: 'Track canceled cleantech projects—investments, setbacks, and market shifts.',
  },
  {
    name: 'Regulations',
    value: 'regulations',
    path: '/research?t=regulations',
    target: '_blank',
    icon: <RegulationsRoundIcon size={32} />,
    color: 'orange',
    title: 'Track the largest cleantech deployments—projects, investments, and trends.',
  },
  {
    name: 'Mergers and Acquisitions',
    value: 'm&a',
  path: `/research?t=${encodeURIComponent('m&a')}`,
    target: '_blank',
    icon: <HandshakeIcon size={32} />,
    color: 'indigo',
    title: 'Track the largest cleantech deployments—projects, investments, and trends.',
  },
  {
    name: 'Thesis Validation',
    value: 'thesisValidation',
    path: '/research?t=thesisValidation',
    target: '_blank',
    icon: <ValidationIcon size={32} />,
    color: 'green',
    title: 'Track the largest cleantech deployments—projects, investments, and trends.',
  },
];

{/* @todo hided report types below until implemented ENKI-4442
  <option value="briefPoints" title="Pulls fresh, real-time data from the internet to ensure the latest market insights. Generates brief responses ideal for quick insights or summaries.">Brief Points</option> 
  <option value="industryReport">Industry Report</option>
  <option value="growthDriver">Growth Driver</option>
  <option value="growthDriverSummary">Growth Driver Summary</option>
  <option value="worstCaseScenario">Worst Case Scenario</option>
  <option value="summarization">Summarization</option>
  <option value="companyActivities">Company Activities</option>
  <option value="targetArea">Target Area</option> 
*/}

export default reportTypeItems;
